<template>
  <smd-one-col-layout class="modal-terms-and-conditions">
    <smd-header slot="header" nav>
      <span class="ns-icon-ico027"
            slot="left-actions"
            @click="closeModal"/>

      <text-string label-id="txt131"/>

      <span class="ns-icon-ico001"
            slot="right-actions">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
    </smd-header>

    <text-string label-id="txt1477" class="m-b-20"/>

    <div class="smd-checkbox__row">
      <smd-checkbox v-model="termsAgreed">
        <p class="Body3">I agree to the terms & conditions above</p>
      </smd-checkbox>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import CloseModalMixin from '@/mixins/close-modal-mixin';
  import {mapFields} from 'vuex-map-fields';

  export default {
    name: "modal-terms-and-conditions-freestyle",
    mixins: [CloseModalMixin],
    computed: {
      ...mapFields('program', {
        termsAgreed: 'termsAgreed',
      }),
    },
  }
</script>

<style lang="scss">
  @import "@/assets/styles/applications.scss";

  .modal-terms-and-conditions {
    .smd-checkbox__row {
      margin-bottom: space(m);

      .smd-checkbox {
        align-items: flex-start;
      }
    }
  }
</style>